/**
 * Export `coookies`.
 */

export const cookies = {
  cookiesAccepted: 'cookies-accepted',
  newsletterPopupClosed: 'newsletter-popup-closed'
};
